import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { Search } from '@material-ui/icons';
import { InputAdornment } from '@material-ui/core';
import ModalFilterBPartner from 'components/Tvendo/Common/ModalFilterBPartner';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsFindBy } from 'services/WService.js';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [sellers, setSellers] = useState([]);

  const [openModalBPartner, setOpenModalBPartner] = useState(false); //Abrir modal
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listSeller() {
    let response = await wsFindBy('base/seller', { seller_type: 'S' });
    if (response.success) setSellers(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return { CardCode: item.CODIGO, SlpCode: item.CODIGOV, CuotaSoles: item.CUOTA,  PromedioSoles: item.PROMEDIO, ItemPedidoPromedio: item.ITEMPEDIDO };
        }),
        CardName: dataImport.nameFile
      });
    } else if (dataImport?.success === false) {
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.id) {
      setDataChanging((prev) => ({
        ...prev,
        SlpCode: bPartnerSelect?.SlpCode || '',
      }));
    }
  }, [bPartnerSelect]);

    useEffect(() => {
      if (customerPortfolioB.open) {
        if (!customerPortfolioB.id) listSeller();
        setDataChanging(customerPortfolioB);
      }
    }, [customerPortfolioB.open]);

  return (
    <>
      {openModalBPartner ? (
        <ModalFilterBPartner
          open={openModalBPartner}
          setOpen={setOpenModalBPartner}
          cardType="C"
          entity="base/business-partner"
          setBPartnerSelect={setBPartnerSelect}
        />
      ) : undefined}

      <Modal
        title={`Nueva Cuota de clientes`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          bPartnerSelect?.id
            ? 'sale/customer-quote-winter'
            : 'sale/customer-quote-winter/multiple'
        }
        dataForce={
          bPartnerSelect?.id
            ? {
                CardCode: bPartnerSelect?.CardCode,
                SlpCode: dataChanging.SlpCode,
                CuotaSoles: dataChanging.CuotaSoles,
                PromedioSoles: dataChanging.PromedioSoles,
                ItemPedidoPromedio: dataChanging.ItemPedidoPromedio,
              }
            : {
                CardCode: cuota.valueSearch?.CardCode,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
        // Estado del registro
        // state
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <TextField
            key={openModalBPartner + bPartnerSelect?.CardName}
            label="Cliente"
            type="text"
            defaultValue={bPartnerSelect?.CardName || ''}
            margin="normal"
            onFocus={(e) => {
              e.preventDefault();
              e.currentTarget.blur();
            }}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment
                  style={{ cursor: 'pointer', color: '#07c107' }}
                  onClick={() => setOpenModalBPartner(true)}
                  position="start"
                >
                  <Search />
                </InputAdornment>
              )
            }}
            fullWidth
          />

          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate="CODIGO"
            sortDuplicate="CODIGO"
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de cuota para Cliente`,
              fields: ['CODIGO', 'CODIGOV', 'CUOTA', 'PROMEDIO', 'ITEMPEDIDO']
            }}
          />
        </span>
        {bPartnerSelect?.id ? (
            <>
              <Autocomplete
                disableClearable
                options={sellers}
                getOptionLabel={(item) => `${item.SlpName} (Código: ${item.SlpCode})`}
                renderInput={(params) => (
                  <TextField {...params} label="Vendedor" margin="normal" required />
                )}
                onChange={(e, item) => handleChange('SlpCode', item?.SlpCode)}
                value={sellers.find(seller => seller.SlpCode === dataChanging.SlpCode) || null}
              />
            </>
          ) : undefined}
          {bPartnerSelect?.id ? (
            <TextField
              label="Cuota en soles"
              fullWidth
              type="number"
              name="CuotaSoles"
              margin="normal"
              value={dataChanging.CuotaSoles || ''}
              onChange={(e) => handleChange('CuotaSoles', e.target.value)}
              required
            />
          ) : undefined}
        {bPartnerSelect?.id ? (
          <TextField
            label="Promedio en soles"
            fullWidth
            type="number"
            name="PromedioSoles"
            margin="normal"
            value={dataChanging.PromedioSoles || ''}
            onChange={(e) => handleChange('PromedioSoles', e.target.value)}
            required
          />
        ) : undefined}
        {bPartnerSelect?.id ? (
          <TextField
            label="Item de pedido Promedio"
            fullWidth
            type="number"
            name="ItemPedidoPromedio"
            margin="normal"
            value={dataChanging.ItemPedidoPromedio || ''}
            onChange={(e) => handleChange('ItemPedidoPromedio', e.target.value)}
            required
          />
        ) : undefined}
      </Modal>
    </>
  );
});
